import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DynamicModuleLoader } from 'redux-dynamic-modules-react';
import getRootModule from 'RootModule';
import getProductsMassiveUploadModule from '../getProductsMassiveUploadModule';
import { layoutContext } from 'context';
import { useHistory } from 'react-router-dom';
import { Form } from 'antd';
import {
  MassiveUploadTable,
  UploadExcelButton,
  ActionButtonsExcelUpload,
} from 'common/MassiveUploads/components';
import { triggerModalForDuplicates } from 'common/MassiveUploads/utils';
//cambiar sagas
import {
  productsMassiveUploadSetAllowUpload,
  productsMassiveUploadRequestVerify,
  productsMassiveUploadRequestUpload,
  productsMassiveUploadClearUpload,
  productsMassiveUploadClearVerify,
  productsMassiveUploadClearAllowUpload,
} from '../redux-saga/actions';
import tableColumns from '../schemas/massiveUploadTableColumns'; //cambiar columna

const ProductsMassiveUpload = (props) => {
  const {
    productsMassiveUploadSetAllowUpload: setAllowUpload,
    productsMassiveUploadRequestVerify: requestVerify,
    productsMassiveUploadRequestUpload: requestUpload,
    productsMassiveUploadClearUpload: clearUpload,
    productsMassiveUploadClearVerify: clearVerify,
    productsMassiveUploadClearAllowUpload: clearAllowUpload,
    allowUpload,
    verify,
  } = props;
  const history = useHistory();
  const [form] = Form.useForm();
  const { onChangeActiveComponent } = useContext(layoutContext);
  const [fileString, setFileString] = useState('');
  const [disabledButton, setDisabledButton] = useState(false);

  const correct = verify?.correct;
  const entriesList = verify?.objectList;
  const totalDuplicatedEntries = verify?.replaced?.length;
  const allCorrectMessage = verify?.allCorrectMessage;

  useEffect(() => {
    clearAllowUpload();
    return () => {
      clearAllowUpload();
      clearUpload();
      clearVerify();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    onChangeActiveComponent('activo');
    if (correct > 0) {
      setAllowUpload(true);
    } else {
      setAllowUpload(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [correct]);

  useEffect(() => {
    if (verify && !verify.allCorrectMessage) {
      setDisabledButton(false);
    }
  }, [verify]);

  function customRequest({ file }) {
    requestVerify({ file, setFileString });
    setDisabledButton(true);
  }

  function requestReplace() {
    requestUpload({ history, fileString, overwrite: true });
  }
  function requestKeep() {
    requestUpload({ history, fileString, overwrite: false });
  }
  function onSubmit() {
    if (totalDuplicatedEntries > 0) {
      triggerModalForDuplicates(
        totalDuplicatedEntries,
        requestReplace,
        requestKeep,
        'carga masiva de productos'
      );
      return;
    }

    requestReplace();
  }
  function onCancel() {
    history.push(`/catalog`);
  }

  return (
    <Form form={form}>
      <UploadExcelButton customRequest={customRequest} disabled={disabledButton} />
      <MassiveUploadTable
        data={entriesList}
        columns={tableColumns}
        allCorrectMessage={allCorrectMessage}
      />
      <ActionButtonsExcelUpload
        onSubmit={onSubmit}
        onCancel={onCancel}
        disabled={!allowUpload}
        buttons={['cancel', 'submit']}
      />
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    allowUpload: state?.PRODUCTS_MASSIVE_UPLOAD?.allowUpload,
    verify: state?.PRODUCTS_MASSIVE_UPLOAD?.verify,
  };
};

const ConnectedProductsMassiveUpload = connect(mapStateToProps, {
  productsMassiveUploadSetAllowUpload,
  productsMassiveUploadRequestVerify,
  productsMassiveUploadRequestUpload,
  productsMassiveUploadClearUpload,
  productsMassiveUploadClearVerify,
  productsMassiveUploadClearAllowUpload,
})(ProductsMassiveUpload);

const ProductsMassiveUploadWithModules = () => {
  return (
    <DynamicModuleLoader modules={[getRootModule(), getProductsMassiveUploadModule()]}>
      <ConnectedProductsMassiveUpload />
    </DynamicModuleLoader>
  );
};
export default ProductsMassiveUploadWithModules;
